import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { mapProfile } from "@/lib/adapt";
import { useSaved } from "@/context/SavedContext";
import { ProfileCard } from "@/components/ProfileCard";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { Bookmark } from "lucide-react";

export default function Saved() {
  const [profiles, setProfiles] = useState(null);
  const { isSaved } = useSaved();

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/saved"); setProfiles((data.profiles || []).map(mapProfile)); }
      catch (err) { toast.error(formatApiError(err.response?.data?.detail)); setProfiles([]); }
    })();
  }, []);

  const visible = (profiles || []).filter((p) => (isSaved ? isSaved(p.id) : true));

  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 text-white shadow-sm"><Bookmark className="h-6 w-6" /></div>
        <div>
          <h1 className="font-serif text-3xl font-bold text-emerald-950 sm:text-4xl">Saved Profiles</h1>
          <p className="text-sm text-slate-500">Your shortlist — revisit these before you decide</p>
        </div>
      </div>

      {profiles === null ? (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="aspect-[3/4] rounded-3xl" />)}</div>
      ) : visible.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-3xl border border-dashed border-emerald-300 bg-white py-20 text-center" data-testid="saved-empty">
          <Bookmark className="mb-3 h-10 w-10 text-amber-500" />
          <h3 className="font-serif text-2xl font-semibold text-emerald-900">No saved profiles yet</h3>
          <p className="mt-2 max-w-sm text-slate-500">Tap the bookmark on any profile to shortlist them here.</p>
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="saved-grid">
          {visible.map((p, i) => <ProfileCard key={p.id} profile={p} index={i} showActions={false} />)}
        </div>
      )}
    </div>
  );
}
